import { render } from "./BrandValue.vue?vue&type=template&id=716d2e52"
import script from "./BrandValue.vue?vue&type=script&lang=js"
export * from "./BrandValue.vue?vue&type=script&lang=js"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__